import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ISystemModuleForSelection } from '../plan-selection-wizard/plan-selection.models';

interface IPlanSolutionModulesDialogData {
  solutionName: string;
  modules: ISystemModuleForSelection[];
  preSelectedModuleIds?: string[];
  planName?: string;
  variationCode?: string;
  productTypeLabel?: string;
  statusLabel?: string;
}

@Component({
  selector: 'app-plan-solution-modules-dialog',
  templateUrl: './plan-solution-modules-dialog.component.html',
  styleUrls: ['./plan-solution-modules-dialog.component.sass'],
})
export class PlanSolutionModulesDialogComponent {
  selectedIds = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<PlanSolutionModulesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IPlanSolutionModulesDialogData
  ) {
    const preSelected = Array.isArray(data?.preSelectedModuleIds) ? data.preSelectedModuleIds : [];
    preSelected.forEach((id) => this.selectedIds.add(String(id)));
  }

  toggle(moduleId: string): void {
    const id = String(moduleId || '').trim();
    if (!id) return;
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
      return;
    }
    this.selectedIds.add(id);
  }

  isSelected(moduleId: string): boolean {
    return this.selectedIds.has(String(moduleId || '').trim());
  }

  save(): void {
    const selected = (Array.isArray(this.data?.modules) ? this.data.modules : []).filter((module) =>
      this.selectedIds.has(String(module?.id || '').trim())
    );
    this.dialogRef.close(selected);
  }

  close(): void {
    this.dialogRef.close();
  }
}
